if(document.querySelector('.hero_slider')) {
    new Splide('.hero_slider', {
        type: 'loop',
        // fixedWidth: "90vw",
        height: '100%',
        width: '100%',
        arrows: true,
        pagination: true,
        autoplay: false,
        interval: 5000,
        pauseOnHover: false,
        pauseOnFocus: false,
        // cover      : false,
		// heightRatio: 0.55,
        breakpoints: {
            640: {
                height: '100%',
            },
      }
    }).mount();
}
// if(event-splide-slider)
if( document.querySelector('.event-splide-slider')){
    new Splide('.event-splide-slider', {
        type: 'loop',
        perPage: 4,
        height: '100%',
        width: '100%',
        arrows: true,
        pagination: true,
        autoplay: false,
        interval: 5000,
        pauseOnHover: false,
        pauseOnFocus: false,
        breakpoints: {
            640: {
                perPage: 1,
            },
            900: {
                perPage: 2,
            },
      }
    }).mount();
}
if(document.querySelector('.post__gallery')) {
    new Splide('.post__gallery', {
        type: 'loop',
        height: '550px',
        arrows: true,
        pagination: true,
        autoplay: true,
        interval: 5000,
        pauseOnHover: false,
        pauseOnFocus: false,
        breakpoints: {
            640: {
                height: '300px',
            },
            // 900: {
            //     height: '400px',
            // },
      }
    }).mount();
}
if(document.querySelector('.two-col-slider')) {
    new Splide('.two-col-slider', {
        type: 'loop',
        height: '550px',
        
        arrows: true,
        pagination: true,
        autoplay: true,
        interval: 2000,
        pauseOnHover: false,
        pauseOnFocus: false,
        breakpoints: {
            640: {
                height: '300px',
            },
            // 900: {
            //     height: '400px',
            // },
      }
    }).mount();
}
    

    

if( document.querySelectorAll('.card__gallery')){
    document.querySelectorAll('.card__gallery').forEach((gallery, index) => {

        const track = gallery.querySelector('.splide__track');
        const list = track.querySelector('.splide__list');
        const allSlides = Array.from(list.querySelectorAll('.splide__slide'));
    
        // Save original slides
        gallery._allSlides = allSlides; // attach to gallery for later use
    
        // Show only first 5 for Splide
        const fragment = document.createDocumentFragment();
        allSlides.forEach((slide, i) => {
            if (i < 5) {
                fragment.appendChild(slide.cloneNode(true));
            }
        });
    
        // Only use first 5 for carousel
        list.innerHTML = '';
        list.appendChild(fragment);
    
        // Initialize Splide
        new Splide(gallery, {
            type: 'slide',
            height: '338px',
            width: '100%',
            arrows: true,
            pagination: true,
            autoplay: false,
            interval: 5000,
            pauseOnHover: false,
            pauseOnFocus: false,
        }).mount();
    });
}
// getLimit



 const modal = document.getElementById('fullscreenModal');
    const modalSliderList = document.getElementById('modalSliderList');
    let modalSplide;

    document.querySelectorAll('.fullscreen-btn').forEach((button, index) => {
        button.addEventListener('click', function () {

            modalSliderList.innerHTML = ''; 
          
            const gallery = this.closest('.gallery-slider'); 
            
            // this is for the elevate experience and host event card galleries full screen

            if( typeof  gallery._allSlides !== 'undefined' ){
                
                const originalSlides  = gallery._allSlides;
            
                originalSlides.forEach(slide => {
                    
                    const img = slide.querySelector('img');
                    let imgSrc;
                    if ('src' in img.dataset) {
                        imgSrc = img.dataset.src;
                       
                      } else {
                        
                        imgSrc = img.src;
                      }
                    if (img) {
                        const li = document.createElement('li');
                        li.classList.add('splide__slide');
                        li.innerHTML = `<img src="${imgSrc}" alt="${img.alt}">`;
                        modalSliderList.appendChild(li);
                      
                    }
                });
            }
            // This is for all the other image galleries
            else{
                const images = gallery.querySelectorAll('.splide__slide img'); 
                images.forEach(img => {
                    let imgSrc;
                    if ('src' in img.dataset) {
                        imgSrc = img.dataset.src;
                       
                      } else {
                        
                        imgSrc = img.src;
                      }
                    const li = document.createElement('li');
                    li.classList.add('splide__slide');
                    li.innerHTML = `<img src="${imgSrc}" alt="${img.alt}">`;
                   
                    modalSliderList.appendChild(li);
                });
                
                
            }
            
            modal.style.display = 'flex';
    
            if (modalSplide) modalSplide.destroy();
    
            modalSplide = new Splide('.modal-slider', {
                type: 'slide',
                height: '85vh',
                width: '100%',
                arrows: true,
                pagination: true,
            }).mount();
        });
    });

    document.querySelector('.close').addEventListener('click', () => {
        modal.style.display = 'none';
    });

    modal.addEventListener('click', (e) => {
        if (e.target === modal) {
            modal.style.display = 'none';
        }
    });